var _rect, _path, _ellipse, _ellipse2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.97339,
    y: 1,
    width: 43.5787,
    height: 43.6,
    rx: 9,
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3129 22.8581C38.3129 31.0826 31.6489 37.749 23.4294 37.749C15.2099 37.749 8.5459 31.0826 8.5459 22.8581C8.5459 14.6337 15.2099 7.96722 23.4294 7.96722C31.6489 7.96722 38.3129 14.6337 38.3129 22.8581Z",
    stroke: "#BCBBBE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8571,
    cy: 19.5704,
    rx: 2.19083,
    ry: 2.19185,
    fill: "#D9D9D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.9066,
    cy: 19.5704,
    rx: 2.19083,
    ry: 2.19185,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1929 26.6938H14.6663C14.6663 29.1596 17.4048 32.7214 23.4296 32.7214C29.4543 32.7214 32.1929 29.4336 32.1929 26.6938Z",
    stroke: "white",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmote);
export default __webpack_public_path__ + "static/media/emote.f1b10a921ee6929b1987c96024f57211.svg";
export { ForwardRef as ReactComponent };